export const switchMode = (dispatch, mode = 'basic') => {
  dispatch({
    type: 'SWITCH_MODE',
    request: {
      mode
    }
  })
}

export const setAdvancedValue = (dispatch, value = '') => {
  dispatch({
    type: 'SET_ADVANCED_VALUE',
    request: {
      value
    }
  })
}
export const setBasicValue = (dispatch, value = {}) => {
  dispatch({
    type: 'SET_BASIC_VALUE',
    request: {
      value
    }
  })
}

export const changeBasicValue = (dispatch, value = {}) => {
  dispatch({
    type: 'CHANGE_BASIC_VALUE',
    request: {
      value
    }
  })
}

export const updateCascadeBasicValue = (dispatch, key, subkey, value = {}) => {
  dispatch({
    type: 'UPDATE_CASCADE_BASIC_VALUE',
    request: {
      key,
      subkey,
      value
    }
  })
}

export const deleteCascadeBasicValue = (dispatch, key, subkey) => {
  dispatch({
    type: 'DELETE_CASCADE_BASIC_VALUE',
    request: {
      key,
      subkey
    }
  })
}

export const deleteBasicValue = (dispatch, keys) => {
  dispatch({
    type: 'DELETE_BASIC_VALUE',
    request: {
      keys
    }
  })
}

export const resetFilters = dispatch => {
  dispatch({
    type: 'RESET_FILTERS'
  })
}
